import { render, staticRenderFns } from "./privacy-and-cookies.vue?vue&type=template&id=44367cee&"
import script from "./privacy-and-cookies.vue?vue&type=script&lang=js&"
export * from "./privacy-and-cookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports